import styled from "styled-components";

export const Container = styled.div`
  background: #FFF;
  padding: 16px;
`